module.exports = __webpack_public_path__ + "static/media/add.ca3efbf7.svg";